import { ApiType } from "@gymflow/common";
import {
  ActivityStatus,
  ApiListRequest
} from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export const appointableCategoriesQueryFn = async ({
  api,
  filter,
  paginationOption,
}: {
  api: ApiType;
  paginationOption: ApiListRequest;
  filter?: {
    statusList?: ActivityStatus[];
  };
}) => {
  return (
    await api.appointableApi.fetchCategories({
      ...paginationOption,
      ...filter,
    })
  ).data;
};

export function useAppointableCategories({
  api,
  paginationOption,
  filter,
}: {
  api: ApiType;
  paginationOption: ApiListRequest;
  filter?: {
    statusList?: ActivityStatus[];
  };
}) {
  return useQuery({
    queryKey: appointableQueryKeys.categories({
      ...paginationOption,
      ...filter,
    }),
    queryFn: () =>
      appointableCategoriesQueryFn({ api, paginationOption, filter }),
  });
}
